<template>
  <div style="position: relative; height: 100%">
    <div class="pt-3">
    <el-form ref="postForm" :model="deliveryLocation" :rules="rules" class="form-container">
      <el-row class="pl-2 pr-3">
        <!-- Title and helper text -->
        <el-col :span="10">
          <el-form-item prop="name" v-if="!widget">
            <label class="font-weight-medium">Location Name*</label>
            <el-input v-model="deliveryLocation.name"></el-input>
          </el-form-item>
          <h3 class="font-weight-bold text-capitalize" v-if="widget">
            {{ `${currentSelectedLocation.name}  (${currentSelectedLocation.address.postCode})` }}
          </h3>
        </el-col>
        <el-col :span="14" class="text-right" v-if="!creatingNewLocation">
          <span class="pl-2" v-if="!widget">
            <el-button
              class="btn btn-text my-2 text-platform-default"
              @click="deleteLocation"
            >
                <i class="fas fa-trash fa-lg mr-2"></i>
            </el-button>
          </span>
        </el-col>
      </el-row>
      <el-row class="pl-4 pr-3" v-if="creatingNewLocation && widget">
        <h3 class="font-weight-bold">
          Manage Delivery Locations
        </h3>
      </el-row>
      <el-row class="pl-2">
        <el-col :span="24">
            <el-row :gutter="20">
              <el-col :xs="20" :sm="12" :md="8" :lg="6">
                <label class="font-weight-medium">Address Line 1*</label>
                <el-form-item prop="address.addressLine1">
                  <el-input v-model="deliveryLocation.address.addressLine1"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="20" :sm="12" :md="8" :lg="6">
                <label class="font-weight-medium">Address Line 2*</label>
                <el-form-item prop="address.addressLine2">
                  <el-input v-model="deliveryLocation.address.addressLine2"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="20" :sm="12" :md="8" :lg="6">
                <label class="font-weight-medium">Country*</label>
                <el-form-item prop="address.country">
                  <el-select
                    style="width: 100%;"
                    size="large"
                    placeholder=""
                    v-model="deliveryLocation.address.country"
                    no-data-text="No data available"
                  >
                    <el-option
                      v-for="item in countriesList"
                      :key="item.value"
                      :label="item.text"
                      :value="item.text"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="20" :sm="12" :md="8" :lg="6">
                <label class="font-weight-medium">Postcode*</label>
                <el-form-item prop="address.postCode">
                  <el-input v-model="deliveryLocation.address.postCode"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="pt-3 pb-2">
              <el-col>
                <h3 class="font-weight-bolder">
                  Contact Details
                </h3>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :xs="20" :sm="12" :md="8" :lg="6">
                <label class="font-weight-medium">
                  Contact Person
                </label>
                <el-form-item prop="contact.name">
                  <el-input v-model="deliveryLocation.contact.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="20" :sm="12" :md="8" :lg="6">
                <label class="font-weight-medium">
                  Phone Number
                </label>
                <el-form-item prop="contact.phone">
                  <el-input v-model="deliveryLocation.contact.phone"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="20" :sm="12" :md="8" :lg="6">
                <label class="font-weight-medium">
                  Email Address
                </label>
                <el-form-item prop="contact.email">
                  <el-input v-model="deliveryLocation.contact.email"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <label class="font-weight-medium">
                  Delivery Notes
                </label>
                <el-form-item prop="notes">
                  <el-input
                    v-model="deliveryLocation.notes"
                    class="defaultTextArea"
                    type="textarea"
                    :rows="3"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
        </el-col>
      </el-row>
      <el-row class="pl-4" v-if="!widget">
        <label class="h7">* Required Fields</label>
      </el-row>
    </el-form>
    </div>
    <br />
    <br />
    <div class="modal-footer justify-content-center">
      <el-button class="btn btn-neutral" size="small" @click="close">
        Close
      </el-button>
      <el-button class="btn btn-neutral" size="small" @click="$emit('emitBack')" v-if="!widget">
        Back
      </el-button>
      <el-button class="btn btn-neutral" size="small" @click="$emit('emitNext')" :disabled="tabIndex >= tabsLength" v-if="!widget">
        Next
      </el-button>
      <el-button class="btn btn-confirm" size="small" @click.prevent="save" :disabled="!hasChangeOccured" :loading="saveBtnLoading">
        Save
      </el-button>
    </div>
  </div>
</template>

<script>
import isEqual from "lodash/isEqual";
import isEmpty from "lodash/isEmpty";

export default {
  components: {},
  mixins: [],
  props: {
    deliveryLocationChangeOccured: {
      type: Boolean,
      default: false,
      required: false
    },
    creatingNewLocation: {
      type: Boolean,
      default: false,
      required: false
    },
    currentSelectedLocation: {
      type: Object,
      default: () => {},
      required: false
    },
    widget: {
      type: Boolean,
      default: false,
      required: false
    },
    tabsLength: {
      type: Number,
      default: 0,
      required: false
    },
    tabIndex: {
      type: Number,
      default: 0,
      required: false
    },
    buyerAccountId: {
      type: String,
      default: "",
      required: true
    }
  },
  data() {
    const validatePostCodeInput = (rule, value, callback) => {
      if (!value) {
        callback(new Error("Required field"));
      } else if (!(/([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})/.test(value))) {
        callback(new Error("Invalid postcode"));
      } else {
        callback();
      }
    }
    const validateInput = (rule, value, callback) => {
      if (value !== "") {
        callback();
      } else {
        callback(new Error("Required field"));
      }
    }
    return {
      saveBtnLoading: false,
      formValid: false,
      rerender: 0,
      deliveryLocation: {
        name: "",
        notes: "",
        company: "",
        meta: {},
        address: {
          addressLine1: "",
          addressLine2: "",
          county: "",
          postCode: "",
          country: "",
        },
        contact: {
          name: "",
          phone: "",
          email: "",
        },
      },
      countriesList: [{
        text: "United Kingdom", value: "UK"
      }],
      rules: {
        name: [
          { required: true, validator: validateInput, trigger: "blur" },
          { required: true, validator: validateInput, trigger: "change" },
        ],
        address: {
          addressLine1: [
            { required: true, validator: validateInput, trigger: "blur" },
            { required: true, validator: validateInput, trigger: "change" },
          ],
          addressLine2: [
            { required: true, validator: validateInput, trigger: "blur" },
            { required: true, validator: validateInput, trigger: "change" },
          ],
          postCode: [
            { required: true, validator: validatePostCodeInput, trigger: "blur" },
            { required: true, validator: validatePostCodeInput, trigger: "change" },
          ],
          country: [
            { required: true, validator: validateInput, trigger: "blur" },
            { required: true, validator: validateInput, trigger: "change" },
          ],
        },
      },
    };
  },
  computed: {
    hasChangeOccured() {
      this.$emit(
        "update:deliveryLocationChangeOccured",
        !isEqual(this.currentSelectedLocation, this.deliveryLocation)
      );
      return !isEqual(this.currentSelectedLocation, this.deliveryLocation);
    },
    hasLocationDetails() {
      return !isEmpty(this.currentSelectedLocation);
    }
  },
  watch: {
    currentSelectedLocation() {
      if (this.hasLocationDetails) {
        this.deliveryLocation = JSON.parse(JSON.stringify(this.currentSelectedLocation));
        this.rerender++;
      }
    },
    creatingNewLocation(newValue) {
      if (newValue) {
        this.deliveryLocation = JSON.parse(JSON.stringify(this.currentSelectedLocation));
        this.rerender++;
      }
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.deliveryLocation = JSON.parse(JSON.stringify(this.currentSelectedLocation));
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  methods: {
    close() {
      if (this.widget) {
        // we will probably use the widget in the basket since it becomes its own dialog then
      } else {
        this.$emit("emitClose")
      }
    },
    deleteLocation() {
      this.$emit("deleteLocation", this.currentSelectedLocation);
    },
    validateForm() {
      this.formValid = false;
      this.$refs["postForm"].validate((valid) => {
        if (valid) {
          this.formValid = true;
        } else {
          this.formValid = false;
        }
      });
    },
    save() {
      this.validateForm();
      if (this.formValid) {
        this.saveBtnLoading = true;
        if (this.creatingNewLocation) {
          this.createLocation();
        } else {
          this.updateLocation();
        }
      }
    },
    async createLocation() {
      const dto = { buyerAccountId: this.buyerAccountId, location: this.deliveryLocation };
      const result = await this.$store.dispatch("deliveryLocations/createDeliveryLocation", dto);
      if (result.status === 200) {
        this.$emit("newDeliveryLocationCreated", result.data.location._id);
      }
      this.saveBtnLoading = false;
    },
    async updateLocation() {
      const result = await this.$store.dispatch("deliveryLocations/updateDeliveryLocation", this.deliveryLocation);
      if (result.status === 200) {
        this.$emit("deliveryLocationUpdated", result.data._id);
      }
      this.saveBtnLoading = false;
    }
  }
};
</script>

<style lang="scss">
</style>
